import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const FilterContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  cursor: 'pointer',
}));

export const IconStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})(({ theme, isSelected }) => ({
  fontSize: '12px',
  color: isSelected
    ? theme.palette.colors.mainFocused
    : theme.palette.colors.lower,
}));

export const LabelStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})(({ theme, isSelected }) => ({
  fontSize: '12px',
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textTransform: 'uppercase',
  color: isSelected
    ? theme.palette.colors.mainFocused
    : theme.palette.colors.lower,
}));
